import { ChangePasswordWrapper } from "./styles";
import { Button } from "../../common/ui/widgets";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userConstants } from "../../user/Constants";
import { setUserPassword } from "../modals/service";
import { Popup } from "../../popup";
import SucessMessage from "./sucessMessage";
import { useTranslation } from "react-i18next";
import { getFeatureToggle } from "../../common/helpers";

export const ChangePassword = () => {
  const { t } = useTranslation();
  const { user, showChangePasswordPopUp } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    (Array.isArray(user) && user[0]) ||
    (user && user.userAccountId ? user : null) ||
    {};
  const userId = currentUser?.userAccountId ?? "";

  const [errorMsg, setErrorMsg] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [currentPasswordErrorMsg, setCurrentPasswordErrorMsg] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMsg1, setErrorMsg1] = useState("");
  const [errorMsg2, setErrorMsg2] = useState("");
  const [errorMsg3, setErrorMsg3] = useState("");
  const [errorMsg4, setErrorMsg4] = useState("");
  const [errorMsg5, setErrorMsg5] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordErrorMsg, setConfirmPasswordErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const validateCurrentPassword = (password) => {
    if (!password || password.length === 0) {
      setCurrentPasswordErrorMsg("Please enter current password.");
      return false;
    }
    setCurrentPasswordErrorMsg("");
    return true;
  };

  const validateNewPassword = (password) => {
    const isStrongPolicy = getFeatureToggle("new_password_policy")[0]?.isVisible ?? true;
    const specialCharRegex = /[^a-zA-Z0-9\s]/;
    const upperCaseCharRegex = /[A-Z]/;
    let minLengthError = false,
      upperCaseError = false,
      specialCharError = false,
      lowerCaseError = false,
      digitError = false;

    if (isStrongPolicy) {
      // Strong policy: min 12, uppercase, lowercase, number, special
      const lowerCaseCharRegex = /[a-z]/;
      const digitRegex = /\d/;

      if (password.length < 12) {
        setErrorMsg1("Min 12 characters required");
        minLengthError = true;
      } else {
        setErrorMsg1("");
      }

      if (!upperCaseCharRegex.test(password)) {
        setErrorMsg2("At least one Uppercase character");
        upperCaseError = true;
      } else {
        setErrorMsg2("");
      }

      if (!lowerCaseCharRegex.test(password)) {
        setErrorMsg3("At least one Lowercase character");
        lowerCaseError = true;
      } else {
        setErrorMsg3("");
      }

      if (!digitRegex.test(password)) {
        setErrorMsg4("At least one Number");
        digitError = true;
      } else {
        setErrorMsg4("");
      }

      if (!specialCharRegex.test(password)) {
        setErrorMsg5("At least one Special character");
        specialCharError = true;
      } else {
        setErrorMsg5("");
      }
    } else {
      // Weak policy: min 8, uppercase, special only
      if (password.length < 8) {
        setErrorMsg1("Min 8 characters required");
        minLengthError = true;
      } else {
        setErrorMsg1("");
      }

      if (!upperCaseCharRegex.test(password)) {
        setErrorMsg2("At least one Uppercase character");
        upperCaseError = true;
      } else {
        setErrorMsg2("");
      }

      setErrorMsg3("");
      setErrorMsg4("");

      if (!specialCharRegex.test(password)) {
        setErrorMsg5("At least one Special character");
        specialCharError = true;
      } else {
        setErrorMsg5("");
      }
    }

    return !(minLengthError || upperCaseError || lowerCaseError || digitError || specialCharError);
  };

  const validateConfirmPassword = (password) => {
    if (!password || password.length == 0) {
      setConfirmPasswordErrorMsg("Please re-enter the password");
      return false;
    }
    if (password !== newPassword) {
      setConfirmPasswordErrorMsg("The passwords do not match");
      return false;
    }
    setConfirmPasswordErrorMsg("");
    return true;
  };

  const [successSubmit, setSuccessSubmit] = useState(false);

  const postChangePassword = () => {
    const isAllNewPasswordValid = validateNewPassword(newPassword);
    const isCurrentPasswordValid = validateCurrentPassword(currentPassword);
    const isConfirmPasswordValid = validateConfirmPassword(confirmPassword);

    if (
      isAllNewPasswordValid &&
      isCurrentPasswordValid &&
      isConfirmPasswordValid
    ) {
      setLoading(true);
      setUserPassword(userId, newPassword, { oldPword: currentPassword })
        .then((r) => {
          setLoading(true);
          if (r.status === "OK") {
            closeChangePasswordPopUp();
            setLoading(false);
            setSuccessSubmit(true);
            setTimeout(() => {
              setSuccessSubmit(false);
              localStorage.clear(); 
              dispatch({
                type: userConstants.LOGOUT,
              });
              window.location.href = '/';
            }, 2000);
          } else if (r.errorCode === "IncorrectPassword") {
            setLoading(true);
            setErrorMsg("Invalid Password");
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error.errorMessage)
        });
    }
  };

  const closeChangePasswordPopUp = () => {
    dispatch({
      type: userConstants.SHOW_CHANGE_PASSWORD_POPUP,
      showChangePasswordPopUp: false,
    });
    setErrorMsg("");
    setCurrentPassword("");
    setCurrentPasswordErrorMsg("");
    setNewPassword("");
    setErrorMsg1("");
    setErrorMsg2("");
    setErrorMsg3("");
    setErrorMsg4("");
    setErrorMsg5("");
    setConfirmPassword("");
    setConfirmPasswordErrorMsg("");
  };

  return (
    <>
      {successSubmit && <SucessMessage />}
      {showChangePasswordPopUp && (
        <>
          <Popup closePopup={closeChangePasswordPopUp}>
            <ChangePasswordWrapper>
              <form>
                <h5>
                  {t("Change Password")}
                </h5>
                {errorMsg && <span className="error-msg">{errorMsg}</span>}
                <label htmlFor="currentPassword"></label>
                <input
                  type="password"
                  name="currentPassword"
                  id="currentPassword"
                  placeholder="Current Password"
                  value={currentPassword}
                  onChange={(e) => {
                    setCurrentPassword(e.target.value);
                    validateCurrentPassword(e.target.value);
                  }}
                />
                {currentPasswordErrorMsg != 0 && (
                  <span className="error-msg">
                    <span className="cross-icon">✕</span>
                    {currentPasswordErrorMsg}
                  </span>
                )}

                <label htmlFor="newPassword"></label>
                <input
                  type="password"
                  name="newPassword"
                  id="newPassword"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    validateNewPassword(e.target.value);
                  }}
                />
                {(errorMsg1 || errorMsg2 || errorMsg3 || errorMsg4 || errorMsg5) && (
                  <span className="error-msg">
                    <span className="cross-icon">✕</span>
                    <div>
                      {errorMsg1 && <p>{errorMsg1}</p>}
                      {errorMsg2 && <p>{errorMsg2}</p>}
                      {errorMsg3 && <p>{errorMsg3}</p>}
                      {errorMsg4 && <p>{errorMsg4}</p>}
                      {errorMsg5 && <p>{errorMsg5}</p>}
                    </div>
                  </span>
                )}

                <label htmlFor="confirmPassword"></label>
                <input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    validateConfirmPassword(e.target.value);
                  }}
                />
                {confirmPasswordErrorMsg && (
                  <span className="error-msg">
                    <span className="cross-icon">✕</span>
                    {confirmPasswordErrorMsg}
                  </span>
                )}

                <div className="footer-btn">
                  <Button handleOnClick={closeChangePasswordPopUp}>
                    {t("CANCEL")}
                  </Button>
                  <Button
                    showloader={loading}
                    primary={true}
                    handleOnClick={postChangePassword}
                  >
                    {t("DONE")}
                  </Button>
                </div>
              </form>
            </ChangePasswordWrapper>
          </Popup>
        </>
      )}
    </>
  );
};
